import axios from 'axios';
import * as urls from '@/constant/urls'
import {Contractor} from '@/interfaces/contractor'

export class ClientApi {
  public request: any;

  constructor() {
    this.request = axios.create({
      baseURL: process.env.VUE_APP_API_URL
    });
  }

  getContractors() {
    return new Promise((resolve, reject) => {
      this.request.get(urls.contractors).then((response:Contractor) => {
        resolve(response);
      }).catch((err:any) => {
        reject(err.response);
      })
    });
  }

  getContractor(uuid:string) {
    return new Promise((resolve, reject) => {
      this.request.get(urls.contractor(uuid)).then((response:Contractor) => {
        resolve(response);
      }).catch((err:any) => {
        reject(err.response);
      })
    });
  }

  getReviewContractor(uuid:string) {
    return new Promise((resolve, reject) => {
      this.request.get(urls.reviewContractor(uuid)).then((response:Contractor) => {
        resolve(response);
      }).catch((err:any) => {
        reject(err.response);
      })
    });
  }

  postReviewContractor(uuid:string, opinion:string) {
    return new Promise((resolve, reject) => {
      this.request.post(urls.reviewContractor(uuid), {opinion}).then((response:Contractor) => {
        resolve(response);
      }).catch((err:any) => {
        reject(err.response);
      })
    });
  }
}
